import studentApi from './api/studentApi';

export const STUDENT_INSERT = 'student/INSERT';
export const STUDENT_LIST = 'student/LIST';
export const STUDENT_SEARCH = 'student/SEARCH';

const initialState = {
	data: null,
	search: null
	
}

export default (state = initialState, action) => {
	switch (action.type) {
		case STUDENT_LIST:
			return {
				...state,
				data: action.payload
			};
		case STUDENT_SEARCH:
			return {
				...state,
				search: action.payload
			};
		default:
			return state;
		
	}
};

export const studentInsert = (payload) => {
	return dispatch => {
		return studentApi.StudentInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentUpdate = (payload, id) => {
	return dispatch => {
		return studentApi.StudentUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentList = (classQuotaId) => {
	return dispatch => {
		return studentApi.StudentList(classQuotaId).then(data => {
			dispatch({
				type: STUDENT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentDelete = (id) => {
	return dispatch => {
		return studentApi.StudentDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};


export const studentListChange = (page, pageSize) => {
	return dispatch => {
		return studentApi.StudentListChange(page, pageSize).then(data => {
			dispatch({
				type: STUDENT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentSearch = (title) => {
	return dispatch => {
		return studentApi.StudentSearch(title).then(data => {
			dispatch({
				type: STUDENT_SEARCH,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentGetResult = (id) => {
	return dispatch => {
		return studentApi.StudentGetResult(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentCreateMany = (payload) => {
	return dispatch => {
		return studentApi.StudentCreateMany(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentEdit = (payload) => {
	return dispatch => {
		return studentApi.StudentEdit(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentGetClassResult = (id) => {
	return dispatch => {
		return studentApi.StudentGetClassResult(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentGetClassReport = (id) => {
	return dispatch => {
		return studentApi.StudentGetClassReport(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const studentGetReport = (id) => {
	return dispatch => {
		return studentApi.StudentGetReport(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};